import WidgetHeaderWide from './WidgetHeaderWide';
export default WidgetHeaderWide;

//# sourceMappingURL=index.js.map